import { render, staticRenderFns } from "./BuscaAssociacoes.vue?vue&type=template&id=dc795044"
import script from "./BuscaAssociacoes.vue?vue&type=script&lang=ts"
export * from "./BuscaAssociacoes.vue?vue&type=script&lang=ts"
import style0 from "./BuscaAssociacoes.vue?vue&type=style&index=0&id=dc795044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports